import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/project/ProjectAreaPage/constants';
import withLicenceAndDisclaimer from '../withLicenceAndDisclaimer';
import * as constants from './constants';
import useCustomReportsPageQueries, { CustomReportsPageQueries } from './useCustomReportsPageQueries';

const CustomReportsPage = lazyWithSuspense(() => import('./CustomReportsPage'));

const page: Page<constants.CustomReportsPageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  authorise: (context, params) => ({
    handler: context.functions.canViewTeam,
    teamId: params.projectId,
  }),
  component: withLicenceAndDisclaimer({
    Component: makePage<constants.CustomReportsPageParams, CustomReportsPageQueries>({
      WrappedPage: CustomReportsPage,
      titleFn: () => i18n._('Custom Reports'),
      parentPathTemplate: `/projects/${parentConstants.ROUTE_PARAM_IDENTIFIER}/overview/stopes/${constants.STOPE_PARAM_IDENTIFIER}`,
      parentTitleFn: () => i18n._('Stope'),
      pageDataHook: useCustomReportsPageQueries,
    }),
  }),
};

export default page;
